import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseDocumentMaskDirective } from './base-document-mask.directive';

type CnpjCacealType = 'cnpj' | 'caceal' | 'both';

@Directive({
  selector: '[jhiCnpjCacealMask]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CnpjCacealMaskDirective),
      multi: true
    }
  ]
})
export class CnpjCacealMaskDirective extends BaseDocumentMaskDirective {
  @Input('jhiCnpjCacealMask') override type: CnpjCacealType = 'both';

  protected validateDocument(value: string): boolean {
    switch (this.type) {
      case 'cnpj':
        return this.isValidCNPJ(value);
      case 'caceal':
        return this.isValidCACEAL(value);
      case 'both':
        return this.isValidCNPJ(value) || this.isValidCACEAL(value);
      default:
        return false;
    }
  }

  protected formatDocument(value: string): string {
    if (this.type === 'caceal') {
      return value.length <= 9 ? this.formatCaceal(value) : value;
    } else if (this.type === 'cnpj') {
      return value.length <= 14 ? this.formatCNPJ(value) : value;
    } else { // both
      return value.length <= 9 ? this.formatCaceal(value) : this.formatCNPJ(value);
    }
  }

  protected getMaxLength(): number {
    if (this.type === 'caceal') {
      return 9;
    }

    if (this.type === 'cnpj') {
      return 14;
    }

    return 14; // both
  }
}
